<script>
import Layout from "../../layouts/main";
import moment from "moment";

export default {
    components: { Layout },
    data() {
        return {
            isLoading: false,
            deudores: [],
            clientes: [],
            filtroResumen: '',
            modalCliente: null,
            modalFacturas: [],
            // quitar mostrarModalFacturas porque usaremos ref
        };
    },
    mounted() {
        this.cargarDeudores();
    },
    methods: {
        cargarDeudores() {
            this.isLoading = true;
            axios.get('/api/get_deudores').then(res => {
                if(res.data.estado){
                    this.deudores = res.data.clientesVencidos;
                    // this.clientes = res.data.clientes;
                    // console.log(this.clientes)
                    // console.log(this.deudores)
                }
                this.isLoading = false;
            });
        },
        formatFecha(fecha) {
            if (!fecha) return '—';
            return moment(fecha).format("DD-MM-YYYY");
        },
        abrirModalFacturas(cli_id) {
            const cliente = this.resumenPorCliente.find(c => c.cli_id === cli_id);
            if (cliente) {
                this.modalCliente = cliente;
                this.modalFacturas = cliente.facturas || [];
                this.$refs.modalFacturas.show();
            }
        },
        cerrarModalFacturas() {
            this.$refs.modalFacturas.hide();
            this.modalCliente = null;
            this.modalFacturas = [];
        },
        getEstadoCliente(cli_id) {
            const cliente = this.deudores.find(c => c.cli_id == cli_id);
            if (!cliente) return '—';
            return cliente.cli_estado;
        },
        exportarResumenClientes() {
    const BOM = '\uFEFF'; // Marca BOM para UTF-8
    const encabezado = 'cli_id;cli_nombre;saldo_total;saldo_vencido;estado;documento;emision;vence;saldo_factura;estado_factura;vendedor\n';
    let filas = [];
    this.resumenPorCliente.forEach(c => {
        if (c.facturas.length) {
            c.facturas.forEach(f => {
                // Encerrar en comillas dobles campos con posible coma o caracteres especiales
                filas.push(
                    `${c.cli_id};"${c.cli_nombre}";${c.saldo_total};${c.saldo_vencido};${f.cli_estado};"${f.documento}";${this.formatFecha(f.emision)};${this.formatFecha(f.vence)};${f.saldo};"${f.estado}";"${f.ven_nombre}"`
                );
            });
        } else {
            filas.push(
                `${c.cli_id};"${c.cli_nombre}";${c.saldo_total};${c.saldo_vencido};${c.estado};;;;;;`
            );
        }
    });
    const csv = BOM + encabezado + filas.join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const fecha = new Date();
    const timestamp = fecha.toISOString().slice(0,10) + '_' + fecha.toTimeString().slice(0,8).replace(/:/g, '');
    a.download = `resumen_clientes_${timestamp}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

    },
    computed: {
        resumenPorCliente() {
            const hoy = new Date();
            const resumen = {};
            this.deudores.forEach(d => {
                if (!resumen[d.cli_id]) {
                    resumen[d.cli_id] = {
                        cli_nombre: d.cli_nombre,
                        ven_nombre: d.ven_nombre,
                        saldo_total: 0,
                        saldo_vencido: 0,
                        facturas_vencidas: [],
                        facturas: []
                    };
                }
                resumen[d.cli_id].saldo_total += Number(d.saldo || 0);
                if (d.vence && new Date(d.vence) < hoy) {
                    resumen[d.cli_id].saldo_vencido += Number(d.saldo || 0);
                    if (Number(d.saldo || 0) > 0) {
                        resumen[d.cli_id].facturas_vencidas.push(d);
                    }
                }
                resumen[d.cli_id].facturas.push(d);
            });
            let resumenArr = Object.keys(resumen).map(id => ({
                cli_id: id,
                cli_nombre: resumen[id].cli_nombre,
                saldo_total: resumen[id].saldo_total,
                saldo_vencido: resumen[id].saldo_vencido,
                facturas_vencidas: resumen[id].facturas_vencidas,
                facturas: resumen[id].facturas,
                ven_nombre: resumen[id].ven_nombre
            }));
            if (this.filtroResumen) {
                return resumenArr.filter(c =>
                    (c.cli_nombre || '').toLowerCase().includes(this.filtroResumen.toLowerCase()) ||
                    (c.cli_id || '').toLowerCase().includes(this.filtroResumen.toLowerCase())
                );
            }
            return resumenArr;
        }
    }
};
</script>

<template>
    <Layout>
        <div class="row">
            <div class="col-12 mt-4">
                <h4>Resumen de saldos por cliente</h4>
                <input v-model="filtroResumen" placeholder="Buscar por nombre o RUT" class="form-control mb-2" />
                <button class="btn btn-success mb-2" @click="exportarResumenClientes">Exportar Resumen a CSV</button>
                <table class="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th>Cliente</th>
                            <th>ID</th>
                            <th>Saldo Total</th>
                            <th>Saldo Vencido</th>
                            <th>Estado</th>
                            <th>Vendedor</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="c in resumenPorCliente" :key="c.cli_id">
                            <td>{{ c.cli_nombre }}</td>
                            <td>{{ c.cli_id }}</td>
                            <td>{{ Number(c.saldo_total).toLocaleString() }}</td>
                            <td>{{ Number(c.saldo_vencido).toLocaleString() }}</td>
                            <td>{{ getEstadoCliente(c.cli_id) }}</td>
                            <td>{{ c.ven_nombre }}</td>
                            <td>
                                <button class="btn btn-info btn-sm" @click="abrirModalFacturas(c.cli_id)">
                                    Ver Facturas
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <b-modal ref="modalFacturas" title="Facturas y Datos del Cliente" size="lg" hide-footer>
            <div v-if="modalCliente">
                <h5>Cliente: {{ modalCliente.cli_nombre }} ({{ modalCliente.cli_id }})</h5>
                <p><strong>Estado:</strong> {{ getEstadoCliente(modalCliente.cli_id) }}</p>
                <p><strong>Saldo Total:</strong> {{ Number(modalCliente.saldo_total).toLocaleString() }}</p>
                <p><strong>Saldo Vencido:</strong> {{ Number(modalCliente.saldo_vencido).toLocaleString() }}</p>
            </div>

            <hr/>

            <div v-if="modalFacturas.length">
                <table class="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th>Documento</th>
                            <th>Emisión</th>
                            <th>Vence</th>
                            <th>Saldo</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="f in modalFacturas" :key="f.documento">
                            <td>{{ f.documento }}</td>
                            <td>{{ formatFecha(f.emision) }}</td>
                            <td>{{ formatFecha(f.vence) }}</td>
                            <td>{{ Number(f.saldo).toLocaleString() }}</td>
                            <td>{{ f.estado || '—' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <p>No hay facturas vencidas para este cliente.</p>
            </div>

            <b-button variant="secondary" block @click="cerrarModalFacturas">Cerrar</b-button>
        </b-modal>
    </Layout>
</template>
